import React, {useCallback, useMemo} from 'react';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {
    Variation,
    Variations,
} from 'components/customer/Confirmation/Checkout/Variations';
import {useDeleteVariations} from 'components/customer/Confirmation/Checkout/helpers/useDeleteVariations';
import {
    removedJobCabinetIdsSet,
    removedJobCabinetIdsUnset,
    selectRemovedJobCabinetIds,
} from 'components/customer/Confirmation/store/confirmationSlice';
import {useGetProductVariations} from 'components/customer/Confirmation/Checkout/helpers/useGetVariations';

export const ProductVariations = () => {
    const {deleteVariation, restoreVariation, isDeleted} = useDeleteVariations(
        selectRemovedJobCabinetIds,
        removedJobCabinetIdsSet,
        removedJobCabinetIdsUnset
    );
    const {job} = useJobContext() as PartialJob;
    const {isLoading, isFetching, variations} = useGetProductVariations();

    const roomIndexes = useMemo(() => {
        const indexes = new Map<number, number>();

        if (job && job?.rooms) {
            job.rooms.forEach((room, index) => {
                indexes.set(Number(room.id), index + 1);
            });
        }

        return indexes;
    }, [job]);

    const getName = useCallback(
        (variation: Variation) => {
            return (
                <>
                    <div>
                        {roomIndexes.get(variation.room_id)}-
                        {variation.room_cab_number} {variation.type_name}
                    </div>
                    <em>({variation.comment})</em>
                </>
            );
        },
        [roomIndexes]
    );

    if (isLoading || isFetching || variations.length == 0) return null;

    return (
        <Variations
            getName={getName}
            deleteAction={deleteVariation}
            restoreAction={restoreVariation}
            isDeleted={isDeleted}
            variations={variations}
        />
    );
};
